<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <p class="mb-0">Crear Nuevo Usuario</p>
                    </div>

                    <div class="card-body">
                        <div v-if="isLoading" class="text-center py-5">
                            Cargando roles...
                        </div>

                        <form v-else @submit.prevent="submitUser">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre Completo</label>
                                    <argon-input v-model="user.full_name" type="text" placeholder="Juan Pérez" />
                                    <small v-if="submitted && v$.user.full_name.$error" class="text-danger">Nombre completo requerido.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Numero de Documento</label>
                                    <argon-input v-model="user.document" type="text" placeholder="Juan Pérez" />
                                    <small v-if="submitted && v$.user.document.$error" class="text-danger">Numero de documento es requerido.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Username</label>
                                    <argon-input v-model="user.username" type="text" placeholder="juan.perez" />
                                    <small v-if="submitted && v$.user.username.$error" class="text-danger">Username requerido.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Email</label>
                                    <argon-input v-model="user.email" type="email" placeholder="email@dominio.com" />
                                    <small v-if="submitted && v$.user.email.$error" class="text-danger">Email requerido y válido.</small>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-control-label">Rol</label>
                                    <select class="form-control" v-model.number="user.role_id">
                                        <option :value="null">Seleccione un rol</option>
                                        <option v-for="role in roles" :key="role.id" :value="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <small v-if="submitted && v$.user.role_id.$error" class="text-danger">Rol requerido.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Contraseña Inicial</label>
                                    <argon-input v-model="user.password" type="password" placeholder="Mínimo 8 caracteres" />
                                    <small v-if="submitted && v$.user.password.$error" class="text-danger">Contraseña requerida.</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Estado</label>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="isActiveSwitch" v-model="user.is_active" :true-value="1" :false-value="0">
                                        <label class="form-check-label" for="isActiveSwitch">{{ user.is_active === 1 ? 'Activo' : 'Inactivo' }}</label>
                                    </div>
                                </div>
                            </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Crear Usuario
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

const companyId = localStorage.getItem('companyId');

export default {
    name: "CreateUser",
    components: { ArgonInput, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            isLoading: true,
            submitted: false,
            roles: [],
            user: {
                username: '',
                email: '',
                role_id: null,
                full_name: '',
                document: '',
                is_active: 1, // Por defecto ACTIVO
                company: parseInt(companyId),
                password: '', // REQUERIDO aquí
            }
        };
    },
    validations() {
        return {
            user: {
                full_name: { required: helpers.withMessage('Requerido', required) },
                username: { required: helpers.withMessage('Requerido', required) },
                document: { required: helpers.withMessage('Requerido', required) },
                email: {
                    required: helpers.withMessage('Requerido', required),
                    email: helpers.withMessage('Email inválido', email)
                },
                role_id: { required: helpers.withMessage('Rol requerido', required) },
                is_active: { required: helpers.withMessage('Estado requerido', required) },
                password: { required: helpers.withMessage('Contraseña requerida', required) },
            }
        };
    },
    mounted() {
        this.fetchRoles();
    },
    methods: {
        async fetchRoles() {
            this.isLoading = true;
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            try {
                const rolesResponse = await axios.get(this.$store.state.apiURL + 'roles', config);
                this.roles = rolesResponse.data;
            } catch (error) {
                console.error("Error al cargar roles:", error.response || error);
                this.handleSessionError(error);
            } finally {
                this.isLoading = false;
            }
        },

        async submitUser() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({ title: 'Datos inválidos', text: 'Por favor, revisa los campos requeridos.', icon: 'warning', confirmButtonColor: '#0b9257' });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const reqConfig = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

            try {
                // 🛑 POST para creación 🛑
                await axios.post(`${apiURL}users`, this.user, reqConfig);

                Swal.fire({
                    title: 'Creado',
                    text: `El usuario ${this.user.username} fue creado correctamente.`,
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/settings/users');
                });

            } catch (err) {
                console.error('Error al guardar usuario:', err.response || err);
                const errorText = (err.response && err.response.data && err.response.data.message)
                                 ? err.response.data.message : 'No se pudo crear el usuario. Verifique que el Username no exista.';
                Swal.fire({ title: 'Error', text: errorText, icon: 'error', confirmButtonColor: '#0b9257' });
            }
        },

        // Manejo de error de sesión (mantenido)
        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
};
</script>